"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var Congrats_1 = __importDefault(require("./components/Congrats"));
var CurveText_1 = __importDefault(require("./components/CurveText"));
var Roulette_1 = __importDefault(require("./components/Roulette"));
var promoRewards_1 = require("./promoRewards");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useAnimation_1 = __importDefault(require("./useAnimation"));
var initialPrizes = [
    { id: 'bonus150', active: false, degree: 120 },
];
var getWheelSections = function (data) {
    var wheelSections = data === null || data === void 0 ? void 0 : data.map(function (reward, i) {
        var value = reward.bonus;
        return {
            id: (reward === null || reward === void 0 ? void 0 : reward.id) || "".concat(i),
            value: value,
            description: reward.description || '%',
        };
    });
    return wheelSections;
};
var timerInHour = new Date(new Date().getTime() + 60 * 60 * 1000);
var Wheel = function (_a) {
    var _b = _a.rewards, rewards = _b === void 0 ? promoRewards_1.promoRewards : _b;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var t = (0, next_intl_1.useTranslations)('wheel');
    var tTimer = (0, next_intl_1.useTranslations)('timer');
    var _c = (0, react_1.useState)(1), spins = _c[0], setSpins = _c[1];
    var _d = (0, react_1.useState)(), wheelSections = _d[0], setWheelSections = _d[1];
    var _e = (0, react_1.useState)(false), isRolling = _e[0], setRolling = _e[1];
    var _f = (0, react_1.useState)(initialPrizes), prizes = _f[0], setPrizes = _f[1];
    var _g = (0, react_1.useState)(false), isOpenCograts = _g[0], setIsOpenCongrats = _g[1];
    (0, react_1.useEffect)(function () {
        var wheelSectionsData = getWheelSections(rewards);
        var degree = 360 / wheelSectionsData.length;
        var prizesData = wheelSectionsData.map(function (w, i) { return (__assign(__assign({}, w), { active: false, degree: 360 - degree * i })); });
        setWheelSections(wheelSectionsData);
        setPrizes(prizesData);
    }, []);
    var animateRoulette = (0, useAnimation_1.default)().animateRoulette;
    var customSpin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var prizesWithActive;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    prizesWithActive = prizes.map(function (prize, i) {
                        if (i === 0) {
                            return __assign(__assign({}, prize), { active: true });
                        }
                        return __assign(__assign({}, prize), { active: false });
                    });
                    setRolling(true);
                    return [4 /*yield*/, animateRoulette({ prizes: prizesWithActive })];
                case 1:
                    _a.sent();
                    setRolling(false);
                    setPrizes(prizesWithActive);
                    setSpins(0);
                    return [2 /*return*/];
            }
        });
    }); };
    var activatePrize = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPrizes(prizes.map(function (p) { return (__assign(__assign({}, p), { active: false })); }));
                    return [4 /*yield*/, customSpin()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [animateRoulette, spins, prizes]);
    var activePrize = (0, react_1.useMemo)(function () {
        return prizes.find(function (prize) { return prize.active; });
    }, [prizes.length, spins]);
    (0, react_1.useEffect)(function () {
        if (activePrize) {
            setIsOpenCongrats(true);
        }
    }, [activePrize]);
    var nextSpinTime = (0, common_hooks_1.useTimer)({
        endDate: timerInHour,
    }).time;
    if (!breakpoints || prizes.length < 2)
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.loading },
            react_1.default.createElement(ui_components_1.LoadingSpinner, null)));
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.promoWheel, " ").concat(styles_module_scss_1.default.wrapper) },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                isOpenCograts && (react_1.default.createElement(Congrats_1.default, { isPromo: true, prize: activePrize, onClose: function () { return setIsOpenCongrats(false); } })),
                react_1.default.createElement(Roulette_1.default, { wheelSections: wheelSections, isPromo: true }),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.curveText },
                    react_1.default.createElement(CurveText_1.default, { text: t('promoRibbonTitle') })),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.descr, dangerouslySetInnerHTML: {
                        __html: t.raw("promoModalText"),
                    } }),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.timerWrapper },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.timerText }, t('promoTimerText')),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.timer },
                        nextSpinTime.hours,
                        tTimer('hours'),
                        ":",
                        nextSpinTime.minutes,
                        tTimer('minutes'),
                        ":",
                        nextSpinTime.seconds,
                        tTimer('seconds'))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.features },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.feature },
                        react_1.default.createElement(image_1.default, { src: "/img/wheel/promo/feature-1.png", width: breakpoints.mobile ? 28 : 48, height: breakpoints.mobile ? 28 : 48, alt: "feature-1" }),
                        react_1.default.createElement("span", null, t('promoFeature1'))),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.feature },
                        react_1.default.createElement(image_1.default, { src: "/img/wheel/promo/feature-2.png", width: breakpoints.mobile ? 28 : 48, height: breakpoints.mobile ? 28 : 48, alt: "feature-2" }),
                        react_1.default.createElement("span", null, t('promoFeature2'))),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.feature },
                        react_1.default.createElement(image_1.default, { src: "/img/wheel/promo/feature-3.png", width: breakpoints.mobile ? 28 : 48, height: breakpoints.mobile ? 28 : 48, alt: "feature-3" }),
                        react_1.default.createElement("span", null, t('promoFeature3')))),
                react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.spinButton, " ").concat(styles_module_scss_1.default.fullHeight, " ").concat(spins <= 0 ? styles_module_scss_1.default.spinButtonDisabled : '', " ").concat(isRolling || spins < 0 ? styles_module_scss_1.default.rolling : ''), onClick: function () {
                        !isRolling && spins > 0 && activatePrize();
                    } },
                    react_1.default.createElement("div", null, isRolling ? t('wait') : t('spin')))))));
};
exports.default = Wheel;
